import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import AppTheme from '../shared-theme/AppTheme';
import AppAppBar from '../components/admin/AppAppBar';
import Hero from '../components/landing/Hero';
import LogoCollection from '../components/landing/LogoCollection';
import Footer from '../components/landing/Footer';
import LandingEvent from '../components/landing/LandingEvents';

export default function Landing(props) {  
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <AppAppBar />
      <Hero />
      <div>
        <LandingEvent/>        
        
        <Divider />
        {/* <LogoCollection /> */}
        {/* <Divider /> */}
        <Footer />
      </div>
    </AppTheme>
  );
}
